import { render, staticRenderFns } from "./StepsInventario.vue?vue&type=template&id=52503f41&scoped=true&"
import script from "./StepsInventario.vue?vue&type=script&lang=js&"
export * from "./StepsInventario.vue?vue&type=script&lang=js&"
import style0 from "./StepsInventario.vue?vue&type=style&index=0&id=52503f41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52503f41",
  null
  
)

component.options.__file = "StepsInventario.vue"
export default component.exports